<template>
    <div class="sustainable-page">
        <div class="banner">
            <div class="mask">
                <img src="@/assets/images/sustainable/home-banner.png" alt="可持续发展首页banner图片" />
            </div>
            <div class="content">
                <div class="wrap">
                    <h1>透过每一次的传递，放大价值</h1>
                </div>
            </div>
        </div>
        <div class="main-content">
            <dl class="content-desc">
                <dd>我们认为，在实现公司经营目标，</dd>
                <dd>为股东创造长远价值的同时，</dd>
                <dd>促进环境与社会可持续发展，</dd>
                <dd>是顺丰所肩负的责任。</dd>
                <dd>您的每一次托付，既是承诺更是信任。</dd>
                <dd>顺丰致力，透过每一次传递，</dd>
                <dd>与您一同促进合作、造就美好，</dd>
                <dd>持续放大价值。</dd>
            </dl>
            <router-link :to="{ name: 'sustainableCompany' }" class="link link-company">
                <div class="mask"><img src="@/assets/images/sustainable/link-bg-company.png" alt="企业治理共推高质量发展" /></div>
                <div class="detail-wrap">
                    <h3 class="title">企业治理</h3>
                    <h4 class="detail"><span>共推高质量发展</span></h4>
                    <p class="desc">顺丰致力于实现企业价值与社会价值的融合统一，怀揣推动行业可持续发展的美好愿景，积极探索企业的可持续发展之路。</p>
                </div>
            </router-link>
            <router-link :to="{ name: 'sustainableInnovation' }" class="link link-innovation">
                <div class="mask"><img src="@/assets/images/sustainable/link-bg-innovation.png" alt="零碳未来共赴双碳目标" /></div>
                <div class="detail-wrap">
                    <h3 class="title">零碳未来</h3>
                    <h4 class="detail"><span>共赴双碳目标</span></h4>
                </div>
            </router-link>
            <router-link :to="{ name: 'sustainableCommunity' }" class="link link-partnership">
                <div class="mask"><img src="@/assets/images/sustainable/link-bg-partnership.png" alt="善意美好共创美好生活" /></div>
                <div class="detail-wrap">
                    <h3 class="title">善意美好</h3>
                    <h4 class="detail"><span>共创美好生活</span></h4>
                </div>
            </router-link>
            <router-link :to="{ name: 'sustainablePartnership' }" class="link link-community">
                <div class="mask"><img src="@/assets/images/sustainable/link-bg-community.png" alt="合作共赢共建无限可能" /></div>
                <div class="detail-wrap">
                    <h3 class="title">合作共赢</h3>
                    <h4 class="detail"><span>共建无限可能</span></h4>
                </div>
            </router-link>
            <div class="download">
                <a class="link" href="https://www.sf-express.com/uploads/2022_8a7477b59e.pdf" target="_blank">
                    <img src="@/assets/images/sustainable/download-icon.png" alt="《顺丰控股2022年可持续发展报告》" />
                    <p>下载《顺丰控股2022年可持续发展报告》</p>
                </a>
                <a class="link" href="https://www.sf-express.com/uploads/20210604_IR_RE_1_FINAL_0ba463f3a2.pdf" target="_blank">
                    <img src="@/assets/images/sustainable/download-icon.png" alt="《顺丰控股碳目标白皮书》" />
                    <p>下载《顺丰控股碳目标白皮书》</p>
                </a>
                <!-- <a class="link" href="https://www.sf-express.com/cn/sc/download/20200324-IR-17-2019.PDF" target="_blank">
                    <img src="@/assets/images/sustainable/download-icon.png" alt="《顺丰控股2019社会责任报告》" />
                    <p>下载《顺丰控股2019社会责任报告》</p>
                </a> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SustainableHome'
}
</script>

<style lang="scss" scoped>
@import './common.scss';
.wrap {
    padding-top: 0.96rem;
    padding-left: 0.72rem;
}
.sustainable-page {
    .banner {
        height: 7.5rem;
        .mask:before {
            opacity: 0;
        }
    }
    .main-content {
        padding: 1.08rem 0.72rem;
        background-color: #e8e8e8;
        text-align: left;
        color: #ffffff;
        .content-desc {
            font-size: 0.3rem;
            line-height: 1.8;
            text-align: center;
            color: #000000;
            margin-bottom: 0.94rem;
        }
        .link {
            &.link-community {
                img {
                    object-fit: cover;
                    height: 2.6rem;
                }
            }
            .detail-wrap {
                padding: 0.32rem 0.44rem;
            }
            .title {
                width: 5.16rem;
                font-size: 0.6rem;
                font-weight: 600;
            }
            .detail {
                margin-top: 0.2rem;
            }
            .desc {
                width: 2.6rem;
                height: 4.6rem;
                font-size: 0.27rem;
                line-height: 1.67;
                margin-top: 0.16rem;
            }
        }
        .download {
            margin-top: 1.2rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/sustainable/home.vue